import { render, staticRenderFns } from "./digit-d.vue?vue&type=template&id=4afce43c&"
import script from "./digit-d.vue?vue&type=script&lang=js&"
export * from "./digit-d.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports